var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skill_wrapper"},[_c('ProfileSubsectionTitle',{attrs:{"subsection_title":"Skill"}}),_c('div',{staticClass:"skill_item_wrapper"},_vm._l((_vm.skills),function(skill){return _c('SkillItem',{key:skill.id,attrs:{"skill":skill}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }